import { InjectionToken } from '@angular/core';

export const indexedDbNameToken = new InjectionToken('INDEXED_DB_NAME');